/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LeadAdmissionFlagsInnerAdmissionFlag } from './LeadAdmissionFlagsInnerAdmissionFlag';
import {
    LeadAdmissionFlagsInnerAdmissionFlagFromJSON,
    LeadAdmissionFlagsInnerAdmissionFlagFromJSONTyped,
    LeadAdmissionFlagsInnerAdmissionFlagToJSON,
    LeadAdmissionFlagsInnerAdmissionFlagToJSONTyped,
} from './LeadAdmissionFlagsInnerAdmissionFlag';

/**
 * 
 * @export
 * @interface LeadAdmissionFlagsInner
 */
export interface LeadAdmissionFlagsInner {
    /**
     * 
     */
    id?: string;
    /**
     * 
     */
    lead_id?: string;
    /**
     * 
     */
    flag_id?: string;
    /**
     * 
     */
    is_dismissed?: boolean;
    /**
     * 
     */
    admission_flag?: LeadAdmissionFlagsInnerAdmissionFlag;
}

/**
 * Check if a given object implements the LeadAdmissionFlagsInner interface.
 */
export function instanceOfLeadAdmissionFlagsInner(value: object): value is LeadAdmissionFlagsInner {
    return true;
}

export function LeadAdmissionFlagsInnerFromJSON(json: any): LeadAdmissionFlagsInner {
    return LeadAdmissionFlagsInnerFromJSONTyped(json, false);
}

export function LeadAdmissionFlagsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeadAdmissionFlagsInner {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'lead_id': json['lead_id'] == null ? undefined : json['lead_id'],
        'flag_id': json['flag_id'] == null ? undefined : json['flag_id'],
        'is_dismissed': json['is_dismissed'] == null ? undefined : json['is_dismissed'],
        'admission_flag': json['admission_flag'] == null ? undefined : LeadAdmissionFlagsInnerAdmissionFlagFromJSON(json['admission_flag']),
    };
}

export function LeadAdmissionFlagsInnerToJSON(json: any): LeadAdmissionFlagsInner {
    return LeadAdmissionFlagsInnerToJSONTyped(json, false);
}

export function LeadAdmissionFlagsInnerToJSONTyped(value?: LeadAdmissionFlagsInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'lead_id': value['lead_id'],
        'flag_id': value['flag_id'],
        'is_dismissed': value['is_dismissed'],
        'admission_flag': LeadAdmissionFlagsInnerAdmissionFlagToJSON(value['admission_flag']),
    };
}

